import { render, staticRenderFns } from "./studentMatingDetail.vue?vue&type=template&id=6f9e8c7f&scoped=true&"
import script from "./studentMatingDetail.vue?vue&type=script&lang=js&"
export * from "./studentMatingDetail.vue?vue&type=script&lang=js&"
import style0 from "./studentMatingDetail.vue?vue&type=style&index=0&id=6f9e8c7f&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6f9e8c7f",
  null
  
)

export default component.exports